import { getPath } from '@/router/common'

const baseUrl = {
  title: '核销明细',
  path: 'WriteOffDetailed'
}

export default [
  {
    path: getPath('DetailedIndex', baseUrl),
    name: 'WriteOffDetailed_DetailedIndex',
    component: () =>
      import(
        /* webpackChunkName: "WriteOffDetailed_DetailedIndex" */ '@/views/writeOffDetailed/detailedIndex/index.vue'
      ),
    meta: {
      title: '核销明细'
    }
  }
]
